module.exports = __webpack_public_path__ + "img/localSync.6cd992d4.png";